import { Grid } from 'antd';

const { useBreakpoint: antdUseBreakpoint } = Grid;

export function useBreakpoint() {
  return antdUseBreakpoint();
}
